import { create } from 'zustand';
import { SettingData } from '../dto/EntityRepository';
import { resolveNavLayout } from '../util/navLayout';

interface SettingState {
  setting: SettingData | null;
  setSetting: (value: SettingData) => void;
  clearSetting: () => void;
}

export const useSettingStore = create<SettingState>((set) => ({
  setting: null,
  setSetting: (value) => set({
    setting: {
      ...value,
      navLayout: resolveNavLayout(value.navLayout),
    },
  }),
  clearSetting: () => set({ setting: null }),
}));